import { c as _c } from "react/compiler-runtime";
import { normalizeAddress } from "@opensea/utils";
import { useIsReady } from "@opensea/wallet";
import { useEffect } from "react";
import { useBasicProfile } from "@/hooks/api/use-basic-profile";
import { useAddress } from "@/hooks/wallet";
import { useFlagContext } from "./use-flag-context";
export function FlagContextHandler(t0) {
  const $ = _c(22);
  const {
    setReady
  } = t0;
  const walletReady = useIsReady();
  const address = useAddress();
  const {
    profile,
    fetching: fetchingProfile
  } = useBasicProfile();
  let t1;
  if ($[0] !== setReady) {
    t1 = {
      setReady
    };
    $[0] = setReady;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    setUserId,
    updateContextProperties
  } = useFlagContext(t1);
  let t2;
  if ($[2] !== address || $[3] !== fetchingProfile || $[4] !== profile || $[5] !== setUserId || $[6] !== walletReady) {
    t2 = function setContextUserId() {
      if (walletReady && !fetchingProfile) {
        setUserId(profile?.address && address ? normalizeAddress(profile.address) : undefined);
      }
    };
    $[2] = address;
    $[3] = fetchingProfile;
    $[4] = profile;
    $[5] = setUserId;
    $[6] = walletReady;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const t3 = profile?.address;
  let t4;
  if ($[8] !== address || $[9] !== fetchingProfile || $[10] !== setUserId || $[11] !== t3 || $[12] !== walletReady) {
    t4 = [address, t3, setUserId, walletReady, fetchingProfile];
    $[8] = address;
    $[9] = fetchingProfile;
    $[10] = setUserId;
    $[11] = t3;
    $[12] = walletReady;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  useEffect(t2, t4);
  let t5;
  if ($[14] !== profile?.allowSolanaAccess || $[15] !== profile?.isBetaTester || $[16] !== profile?.isStaff || $[17] !== updateContextProperties) {
    t5 = function setContextBetaTester() {
      if (profile?.isStaff) {
        updateContextProperties({
          isStaff: "true"
        });
      }
      if (profile?.isBetaTester) {
        updateContextProperties({
          isBetaTester: "true"
        });
      }
      if (profile?.allowSolanaAccess) {
        updateContextProperties({
          isFungiblesBetaTester: "true"
        });
      }
    };
    $[14] = profile?.allowSolanaAccess;
    $[15] = profile?.isBetaTester;
    $[16] = profile?.isStaff;
    $[17] = updateContextProperties;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== profile || $[20] !== updateContextProperties) {
    t6 = [profile, updateContextProperties];
    $[19] = profile;
    $[20] = updateContextProperties;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  useEffect(t5, t6);
  return null;
}